import { render, staticRenderFns } from "./EmployeeTerminationPeriods.vue?vue&type=template&id=03ec2d6c&scoped=true&"
import script from "./EmployeeTerminationPeriods.vue?vue&type=script&lang=js&"
export * from "./EmployeeTerminationPeriods.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTerminationPeriods.vue?vue&type=style&index=0&id=03ec2d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ec2d6c",
  null
  
)

export default component.exports